import { ImageIcon } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { BannerEditor } from "./editor";
import { BannerBlockProps } from "./types";
import { BannerEmailRenderer } from "./email";
import { BannerEmailPanelRenderer } from "./email-panel";
import BannerWeb from "./web";
import { BannerWebEditor } from "./web-editor";

export default registerBlock<BannerBlockProps>({
  type: "banner",
  name: "editorBlocksLibrary.blocks.banner.title",
  description: "editorBlocksLibrary.blocks.banner.description",
  Icon: ImageIcon,
  category: BlockCategory.LAYOUT,
  premium: true,
  components: {
    email: {
      component: BannerEmailRenderer,
      editor: {
        component: BannerEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: BannerEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: {
          minSize: 4,
        },
      },
    },
    web: {
      component: BannerWeb,
      editor: {
        component: BannerWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: BannerEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: {
          minSize: 3,
        },
      },
    },
  },
});
